/* eslint-disable no-undef */
import { _ } from '../utils.js'

export default class Sticky {
    constructor(el) {
        this.element = $(el)
        this.placeholderEl = this.element.next(
            _('placeholder', 'element').str(),
        )
        this.menu = _('menu', 'element').node()
        this.menuOpen = this.sticky
        this.upDistance = 0
        this.downDistance = 0
        this.isInEditMode = document.querySelector('.page.page-edit-mode')
            ? true
            : false

        this.classes = {
            stickyActive: 'sticky--active',
            hidden: 'u-hidden',
        }

        let timer
        $(window).on('resize', () => {
            clearTimeout(timer)
            timer = setTimeout(this.getElSizes, 300)
        })

        this.getElSizes()

        if (!this.isInEditMode) {
            document.addEventListener('scroll', this.stick, { passive: true })
        }
    }

    getElSizes = () => {
        this.sticky = {
            top: this.element.offset().top,
            height: this.element.outerHeight(),
        }

        this.placeholder = {
            class: this.classes.hidden,
            style: `height: ${this.sticky.height}px`,
        }
        this.placeholderEl.attr('style', this.placeholder.style)
    }

    stick = () => {
        if (!this.element.hasClass('sticky--removed')) {
            const menuOpen = this.menu.classList.contains('nav--open')
            if (!menuOpen) {
                const docTop = $(document).scrollTop()

                if (docTop > this.sticky.top) {
                    this.element.addClass(this.classes.stickyActive)
                    this.placeholderEl.removeClass(this.classes.hidden)
                } else {
                    this.element.removeClass(this.classes.stickyActive)
                    this.element.removeClass('sticky--hide')
                    this.placeholderEl.addClass(this.classes.hidden)
                }

                if (docTop === 0) {
                    this.element.removeClass(this.classes.stickyActive)
                    this.element.removeClass('sticky--hide')
                    this.placeholderEl.addClass(this.classes.hidden)
                }
                this.unstickPart()
            }
        }
    }

    unstickPart = () => {
        const docTop = $(document).scrollTop()
        const isStickyActive = this.element.hasClass(this.classes.stickyActive)
        const isPersistant = this.element[0].dataset?.stickyPersist
            ? true
            : false

        if (this.oldScroll > docTop) {
            this.upDistance++
            if (this.upDistance < 50) {
                return false
            }
            this.upDistance = 0
            this.downDistance = 0
            this.element.removeClass('sticky--hide')
        } else {
            this.downDistance++
            if (this.downDistance < 50) {
                return false
            }
            this.upDistance = 0
            this.downDistance = 0
            if (docTop > this.sticky.height && isStickyActive && isPersistant) {
                this.element.addClass('sticky--hide')
            }
        }
        this.oldScroll = docTop
    }
}
